module.exports = __webpack_public_path__ + "img/three.b4390470.svg";